<template>

  <v-container
  fluid
  fill-width
  >
    <div class="headline">Filter</div>
    <v-radio-group v-model="filter" row
      @change="changeFilter()"
    >
      <v-radio
          key="Submitted" label="Submitted" value="Submitted"
      ></v-radio>
      <v-radio
          key="Approved" label="Approved" value="Approved"
      ></v-radio>
      <v-radio
          key="Cancelled" label="Cancelled" value="Cancelled"
      ></v-radio>
      <v-radio
          key="New" label="New" value="New"
      ></v-radio>
      <v-radio
          key="Open" label="Open" value="Open"
      ></v-radio>
      <v-radio
          key="All" label="All" value="All"
      ></v-radio>
    </v-radio-group>
    <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
    ></v-text-field>
    <v-data-table
        :headers="headers"
        :items="$store.state.requestSearchResults"
        class="elevation-3"
        itme-key="_id"
        :loading="$store.state.loading > 0"
        :search="search"
        :pagination.sync="pagination"
    >
      <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
      <template v-slot:items="props">
        <td @click="navigateDetails(props.item._id)">{{ props.item._id }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.requestDate }}</td>
        <td>{{ props.item.requester }}</td>
        <td>{{ props.item.requestStatus }}</td>
        <td>{{ props.item.requestLines ? props.item.requestLines.length : 0 }}</td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
  export default {
    name: 'BuybackRequest',
    data() {
      return {
        headers: [
          { text: 'Request Id', value: '_id' },
          { text: 'Name', value: 'name' },
          { text: 'Request Date', value: 'requestDate' },
          { text: 'Requestor', value: 'requester' },
          { text: 'RequestStatus', value: 'requestStatus' },
          { text: 'Lines', value: 'requestLines.length' },

        ],
        filter: 'Open',
        search: '',
        pagination: {
          rowsPerPage: 25,
        },
      };
    },
    components: {
    },
    mounted() {

    },
    methods: {
      navigateDetails(item) {
        console.log('navigating to:', item);
        this.$router.push(`/buyback-requests/${item}`);
      },
      async changeFilter() {
        console.log('filter changed');
        await this.queryData();
      },
      async queryData() {
        await this.$store.dispatch('SEARCH_REQUESTS', this.convertFilterToQuery(this.filter));
      },
      convertFilterToQuery(filter = 'All') {
        switch(filter.toUpperCase()) {
          case 'ALL':
            return 'All';
          case 'SUBMITTED':
            return 'Submitted for Pricing';
          case 'APPROVED':
            return 'Approved for Fulfillment';
          case 'CANCELLED':
            return 'Cancelled';
          case 'NEW':
            return 'New';
          case 'OPEN':
            return 'Open';
          default:
            return 'Open';
        }
      },
    },
    async beforeCreate() {
      await this.$store.dispatch('SEARCH_REQUESTS', 'Open');
    },


    beforeUpdate() {
      console.log('beforeUpdate:', this.filter);
      if (this.filter !== 'All') {
        this.$store.commit('SET_BREADCRUMBS', [
          { text: 'BuyBack Requests', disabled: false, href: '/#/buyback-requests'},
          { text: this.filter, disabled: true },
        ]);
      } else {
        this.$store.commit('SET_BREADCRUMBS', [{ text: 'BuyBack Requests', disabled: true }])
      }
    },
  };
</script>

<style>

</style>
